module.exports = __webpack_public_path__ + "img/gq.b28e17f6.svg";